import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import Swal from "sweetalert2";
import { Asset } from "../../Interfaces/Assets/Asset";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AssetHelper } from "../../Lib/Helper/AssetHelper";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { CartEntryCustomerQuestion, CustomerQuestion } from "../../Models/CustomerQuestion/CustomerQuestion";
import { RetailItem, RetailItemVariant } from "../../Models/Retail/RetailItem";
import { retailHelper } from "../../Lib/Helper/Retail/RetailHelper";
import { ProductDetails } from "../Admin/ProductDetails/ProductDetails";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { AxDropdown, IAxDropdownOptions } from "@axess/limestone";

@ModuleName("RetailDetail")
export class RetailDetail implements AxInit {
    private photoSwipe: PhotoSwipe<PhotoSwipe.Options> = null;
    private swiperAssets: PhotoSwipe.Item[];

    private initData: RetailDetailInitData;
    private questions: CustomerQuestion[];

    private selectedRetailItem: number;
    private allVariants: RetailItemVariant[] = [];

    private selectedQuantity: number = 1;
    private quantitySelection: AxDropdown = new AxDropdown();

    constructor(private _assetHelper = new AssetHelper(),
        private _axLimestone = new AxLimeStone(),
        private _i18nHelper = new I18nHelper(),
        private _retailHelper = new retailHelper()) { }

    AxInit(init: RetailDetailInitData): void {
        this.initData = init;

        this.swiperAssets = this._assetHelper.GetPhotoSwipeItems(init.Assets);
        this.questions = init.Questions;

        this.selectedRetailItem = this.initData.Item.RetailItemNr;

        this.questionEvents();
        this.initVariantSwitch();

        this._retailHelper.setColorPickerColors($('.retail__filter_color'));

        this.quantitySelection.init('.ax-dropdown',
        {
            multiSelect: false,
            searchBar: false,
            onSelect: ($parent, value) => {
                let quantity = parseInt(value as string);
                this.selectedQuantity = quantity;
            }
        });

        this.quantitySelection.setValue('1');

        $('.retail_detail__asset-main').click(x => {
            let src = x.target.getAttribute('src');
            this.initLightBox(src);
        });

        $('.retail_detail__asset-list-item').click(x => {
            this.activateImage(x.target);
        });

        $('.retail_addToCart').click(x => {
            if (!$(x.delegateTarget).prop('disabled')) {
                this._axLimestone.LockButton(x.delegateTarget);
                this.addToCart();
            }
        });

        for (let item of this.initData.VariantItems) {
            this.allVariants.push(...item.Variants.filter(x => this.allVariants.findIndex(y => y.FeatureType === x.FeatureType && y.FeatureName === x.FeatureName && x.FeatureValue === y.FeatureValue) === -1));
        }

        let reloaded = this._retailHelper.checkReload(x => {
            this.loadFilterFromLocalStorage(x);
        }, this.initData.Item.RetailItemNr, true);

        if (this.initData.VariantItems.length === 1) {
            this.checkAddToCartAllowed();
        }
    }

    loadFilterFromLocalStorage(storageFilter: RetailItemVariant[]) {
        if (storageFilter != null && storageFilter.length > 0) {
            for (let filter of storageFilter) {
                let $e = this.getElementFromVariant(filter);

                if ($e.length > 0) {
                    this.activeVariant($e);
                    this.toggleSupportedVariants($e);
                }
            }
        } else {
            this.initVariants();
        }
    }

    initVariants() {
        let variants: RetailItemVariant[];

        if (this.initData.Item.AvailableItems > 0) {
            variants = this.initData.Item.Variants;
        } else {
            let firstItem = this.initData.VariantItems.filter(x => x.AvailableItems > 0)[0];
            variants = firstItem.Variants;
            this.selectedRetailItem = firstItem.RetailItemNr;
        }

        for (let variant of variants) {
            let $elem = this.getElementFromVariant(variant);
            if ($elem.length > 0) {
                this.activeVariant($elem);
            }
        }
    }

    initVariantSwitch() {
        $(`.retail__filter`).click(e => {
            this.activeVariant($(e.delegateTarget));
            this.toggleSupportedVariants($(e.delegateTarget));
        });
    }

    activeVariant($e: JQuery<HTMLElement>) {
        let variant = this.getVariantFromElement($e);
        $e.toggleClass('disabled', false);

        switch (variant.FeatureType) {
            case 6:
                $(`button.retail__filter-chips[data-filterType="${variant.FeatureType}"][data-filterName="${variant.FeatureName}"].ax-chip.retail__filter-chips`).removeClass('active').removeClass('ax-fill-primary');
                this.toggleChip($e);
                break;

            case 2:
                $(`.retail__filter[data-filterType="${variant.FeatureType}"][data-filterName="${variant.FeatureName}"]`).toggleClass('active', false);
                $e.toggleClass('active', true);
                break;

            default:
                break;
        }

        this.switchToItemImage(variant);
    }

    getCurrentVariantList(): RetailItemVariant[] {
        let variantList: RetailItemVariant[] = [];

        for (let activeE of $(`.retail__filter.active`)) {
            variantList.push(this.getVariantFromElement($(activeE)));
        }

        return variantList;
    }

    toggleSupportedVariants($e: JQuery<HTMLElement>) {
        let variant = this.getVariantFromElement($e);
        $(`.retail__filter`).toggleClass('disabled', false);

        let currentVariants: RetailItemVariant[] = this.getCurrentVariantList();
        currentVariants =
            currentVariants.sort(
                (a, b) => a.FeatureType === variant.FeatureType && a.FeatureName === variant.FeatureName ? -1 : 1);
        let deletedVariants: RetailItemVariant[] = [];

        //Search for impossible Combinations
        for (let searchV of currentVariants) {
            let itemsToSearch = this.initData.VariantItems.filter(x => this.itemContainsVariant(x, searchV));

            if (deletedVariants.findIndex(x => x.FeatureType === searchV.FeatureType && x.FeatureName === searchV.FeatureName && x.FeatureValue === searchV.FeatureValue) === -1) {
                for (let otherV of this.allVariants.filter(x => x.FeatureType !== searchV.FeatureType || x.FeatureName !== searchV.FeatureName)) {
                    let itemsWithOtherV = itemsToSearch.filter(x => this.itemContainsVariant(x, otherV));

                    if (itemsWithOtherV.length === 0) {
                        deletedVariants.push(otherV);
                    }
                }
            }
        }

        //Indicate disabled Combinations and deactivate currently selected impossible combinations
        for (let delV of deletedVariants) {
            let $variantE = this.getElementFromVariant(delV);
            $variantE.toggleClass('disabled', true);
            switch (delV.FeatureType) {
                case 6:
                    $variantE.toggleClass('active', false).toggleClass('ax-fill-primary', false);
                    break;

                case 2:
                    $variantE.toggleClass('active', false);
                    break;

                default:
                    break;
            }
        }

        //Activate single Options
        let groupedFilter = this.allVariants.reduce((r, a) => {
            let key = `${a.FeatureType}-${a.FeatureName}`;
            r[key] = r[key] || [];
            r[key].push(a);
            return r;
        }, Object.create(null));

        for (let key of Object.keys(groupedFilter)) {
            let notDeletedFilters: RetailItemVariant[] = groupedFilter[key].filter(x => deletedVariants.findIndex(
                y => x.FeatureType === y.FeatureType &&
                    x.FeatureValue === y.FeatureValue &&
                    x.FeatureName === y.FeatureName) ===
                -1);
            if (notDeletedFilters.length === 1) {
                let $toActive = this.getElementFromVariant(notDeletedFilters[0]);
                this.activeVariant($toActive);
            }
        }

        currentVariants = this.getCurrentVariantList();
        this._retailHelper.saveToLocalStorage(currentVariants, this.initData.Item.RetailItemNr, true);

        this.checkAddToCartAllowed();
    }

    checkAddToCartAllowed() {
        let currentVariants: RetailItemVariant[] = this.getCurrentVariantList();

        let items = this.initData.VariantItems.filter(x => {
            for (let searchV of currentVariants) {
                let vFound = this.itemContainsVariant(x, searchV);
                if (!vFound) {
                    return false;
                }
            }
            return true;
        });

        $('.retail_addToCart').prop('disabled', items.length !== 1);
        if (items.length === 1) {
            this.selectedRetailItem = items[0].RetailItemNr;
            let maxAvailable = (items[0].AvailableItems >= this.initData.MaxItemsPerSelection
                ? this.initData.MaxItemsPerSelection
                : items[0].AvailableItems);
                
            let $dropdownMenu = $(this.quantitySelection.getElements()[0]).find('.ax-dropdown__menu');
            $dropdownMenu.html("");

            for (let i = 1; i <= maxAvailable; i++) {
                const inner = document.createElement("li");
                inner.innerHTML = i.toString();
                inner.classList.add("ax-dropdown__item");
                inner.setAttribute("data-value", i.toString());

                $dropdownMenu.append(inner);
            }

            if (this.selectedQuantity > maxAvailable) {
                this.quantitySelection.setValue('1');
            }

            return;
        }
        this.selectedRetailItem = null;
    }

    activateImage(e: HTMLElement) {
        let index = parseInt(e.getAttribute('data-index'));
        let scaledImagePath = e.getAttribute('data-scaled-image');

        $('.retail_detail__asset-main').attr('data-index', index);
        $('.retail_detail__asset-main').attr('src', scaledImagePath);
    }

    switchToItemImage(variant: RetailItemVariant) {
        let key = `W-${this.initData.RetailItemID}-VA-${variant.FeatureType}-${variant.FeatureName}-${variant.FeatureValue}`;
        let groupKey = `W-${this.initData.RetailItemID}-VA-${variant.FeatureType}-${variant.FeatureName}-`;
        $(`.retail_detail__asset-list-variant[data-identifier^="${groupKey}"]`).addClass('d-none');
        $(`.retail_detail__asset-list-variant[data-identifier="${key}"]`).removeClass('d-none');

        let currentSrc = $('.retail_detail__asset-main').attr('src');
        let $variantActive = $(`.retail_detail__asset-list-variant[src="${currentSrc}"]`);
        let currentlyInvisible = $variantActive.length === 0 || $variantActive.hasClass('d-none');

        if (currentlyInvisible && $(`.retail_detail__asset-list-variant, .retail_detail__asset-list-item`).not('.d-none').length > 0) {
            $(`.retail_detail__asset-list-variant, .retail_detail__asset-list-item`).not('.d-none')[0].click();
        }
    }

    initLightBox(src: string) {
        let swiperAssets = [];
        let count = 0;
        let index = 0;

        for (let image of $(`.retail_detail__asset-list-variant, .retail_detail__asset-list-item`).not('.d-none')) {
            let imageSrc = $(image).attr('src');
            let tmp = this.swiperAssets.find(x => x.src == imageSrc);
            swiperAssets.push(tmp);

            if (imageSrc == src) {
                index = count;
            }

            count++;
        }


        if (this.swiperAssets != null) {
            let swipeElem = document.querySelectorAll('.pswp')[0] as HTMLElement;
            this.photoSwipe = new PhotoSwipe<PhotoSwipeUI_Default.Options>(swipeElem, PhotoSwipeUI_Default, swiperAssets, {
                index: index,
                closeEl: true,
                captionEl: false,
                fullscreenEl: false,
                zoomEl: false,
                shareEl: false,
                counterEl: false,
                arrowEl: false,
                preloaderEl: true,
                bgOpacity: 0.85,
                history: false
            });
            this.photoSwipe.init();
        }
    }

    questionEvents() {
        $('.retail_detail__input-list button.ax-chip').click(x => {
            let $target = $(x.delegateTarget);
            let questionID = parseInt($target.attr('data-target'));

            $target.parent().find('.active').each((i, e) => {
                this.toggleQuestionChip($(e));
            });

            this.toggleQuestionChip($target);
            this.questions.find(x => x.QuestionID == questionID).Answer = $target.attr('data-value');
        });
    }

    toggleQuestionChip($target: JQuery<HTMLElement>) {
        $target.toggleClass('active').toggleClass('ax-fill-primary');
        $target.find('i.las').toggleClass('ax-color-primary').toggleClass('color-white');
        $target.find('i.lar').toggleClass('ax-color-primary--light').toggleClass('color-white');
    }

    addToCart() {
        let answerList: CartEntryCustomerQuestion[] = [];
        let error: boolean = false;
        let errorMsg: string = "";
        for (let quest of this.questions) {
            let mandatoryButEmpty = false;

            if (quest.QuestionType != 3 && quest.QuestionType != 4 && quest.QuestionType != 5) {
                let qElem = document.getElementsByName(`retail_q_${quest.QuestionID}`)[0] as HTMLInputElement;
                mandatoryButEmpty = quest.Mandatory && qElem.value.trim() == '';
                answerList.push({
                    QuestionID: quest.QuestionID,
                    Value: qElem.value
                });
            } else {
                mandatoryButEmpty = quest.Mandatory && quest.Answer.trim() == '';
                answerList.push({
                    QuestionID: quest.QuestionID,
                    Value: quest.Answer
                });
            }

            if (mandatoryButEmpty) {
                error = true;
                errorMsg += this._i18nHelper.GetTranslation(Translations.FeldErforderlich, quest.Name) + '<br />';
            }
        }

        if (error) {

            Swal.fire({
                title: this._i18nHelper.GetTranslation(Translations.ValueMissing),
                icon: 'warning',
                html: errorMsg
            });

            this._axLimestone.UnlockButton($('.retail_addToCart')[0]);
            return;
        }

        AxessViewer.loadPartialView(this.initData.PostURL, { retailItemID: this.selectedRetailItem, questions: answerList, quantity: this.selectedQuantity }, result => {


            AxLoad.LoadModule('AxFireShoppingCartModal', {
                result: result,
                continueShoppingPath: 'Retail',
                btn: $('.retail_addToCart')[0],
                ResetQuantity: false
            });
            /*  fireShoppingCart(result, false);*/
            this._axLimestone.UnlockButton($('.retail_addToCart')[0]);
        }, {
            silent: true,
            skipShoppingCartReload: false,
        });
    }

    itemContainsVariant(item: RetailItem, variant: RetailItemVariant): boolean {
        return item.Variants.findIndex(x => x.FeatureType === variant.FeatureType &&
            x.FeatureName === variant.FeatureName &&
            x.FeatureValue === variant.FeatureValue) !==
            -1;
    }

    toggleChip($target: JQuery<HTMLElement>) {
        $target.toggleClass('active').toggleClass('ax-fill-primary');
    }

    getElementFromVariant(variant: RetailItemVariant): JQuery<HTMLElement> {
        return $(`.retail__filter[data-filterType="${variant.FeatureType}"][data-filterName="${variant.FeatureName}"][value="${variant.FeatureValue}"]`);
    }

    getVariantFromElement($e: JQuery<HTMLElement>): RetailItemVariant {
        return {
            FeatureType: parseInt($e.attr('data-filterType') as string),
            FeatureValue: $e.val() as string,
            FeatureName: $e.attr('data-filterName') as string,
            VariantRelated: false,
            Color: $e.css('background-color')
        };
    }
}

interface RetailDetailInitData {
    RetailItemID: number;
    Questions: CustomerQuestion[];
    Assets: Asset[];
    PostURL: string;
    VariantItems: RetailItem[];
    Item: RetailItem;
    MaxItemsPerSelection: number;
    VariantDetailList: ProductDetails[];
}